import { useContext } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Components
import { useCancelReturn } from "./useCancelReturn";
// MUI
import Button from "@mui/material/Button";

export const ReturnCancelButton = ({
  returnData,
  setReturnData,
  setActiveStep,
}) => {
  const { mutate, isSuccess, data } = useCancelReturn();
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const handleOnClick = () => {
    const no = returnData.data.data.returnOrder.no;
    mutate({
      data: { filter: { noFilter: no } },
    });
  };

  // Success Function
  const successFunc = () => {
    setReturnData({});
    setActiveStep(0);
  };
  // Error Function
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "error",
    });
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <Button
      variant="outlined"
      size="large"
      color="error"
      onClick={handleOnClick}
    >
      Cancel
    </Button>
  );
};
